var FexiosErrorCodes = /* @__PURE__ */ ((FexiosErrorCodes2) => {
  FexiosErrorCodes2["BODY_USED"] = "BODY_USED";
  FexiosErrorCodes2["NO_BODY_READER"] = "NO_BODY_READER";
  FexiosErrorCodes2["TIMEOUT"] = "TIMEOUT";
  FexiosErrorCodes2["NETWORK_ERROR"] = "NETWORK_ERROR";
  FexiosErrorCodes2["BODY_NOT_ALLOWED"] = "BODY_NOT_ALLOWED";
  FexiosErrorCodes2["HOOK_CONTEXT_CHANGED"] = "HOOK_CONTEXT_CHANGED";
  FexiosErrorCodes2["ABORTED_BY_HOOK"] = "ABORTED_BY_HOOK";
  FexiosErrorCodes2["INVALID_HOOK_CALLBACK"] = "INVALID_HOOK_CALLBACK";
  FexiosErrorCodes2["UNEXPECTED_HOOK_RETURN"] = "UNEXPECTED_HOOK_RETURN";
  FexiosErrorCodes2["UNSUPPORTED_RESPONSE_TYPE"] = "UNSUPPORTED_RESPONSE_TYPE";
  FexiosErrorCodes2["FEATURE_MOVED_TO_PLUGIN"] = "FEATURE_MOVED_TO_PLUGIN";
  FexiosErrorCodes2["BODY_TRANSFORM_ERROR"] = "BODY_TRANSFORM_ERROR";
  return FexiosErrorCodes2;
})(FexiosErrorCodes || {});
class FexiosError extends Error {
  constructor(code, message, context, options) {
    super(message, options);
    this.code = code;
    this.context = context;
  }
  name = "FexiosError";
  static is(e, code) {
    if (!(e instanceof FexiosError) || e instanceof FexiosResponseError) {
      return false;
    }
    return code ? e.code === code : true;
  }
}
class FexiosResponseError extends FexiosError {
  constructor(message, response, options) {
    super(response.statusText, message, void 0, options);
    this.response = response;
  }
  name = "FexiosResponseError";
  static is(e) {
    return e instanceof FexiosResponseError;
  }
}
const isFexiosError = (e) => {
  return FexiosError.is(e);
};

export { FexiosErrorCodes as F, FexiosError as a, FexiosResponseError as b, isFexiosError as i };
//# sourceMappingURL=fexios.B-14qd8n.mjs.map
